import script from "./Resolve.vue?vue&type=script&setup=true&lang=js"
export * from "./Resolve.vue?vue&type=script&setup=true&lang=js"

import "./Resolve.vue?vue&type=style&index=0&id=5435830e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5435830e"]])

export default __exports__